import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { AppConfig } from '../_helpers/appconfig.service';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

@Injectable()
export class CommonDataService {

  _kcmssvcURL: string = AppConfig.settings.apiServer.kcmssvcURL.toString();

  httpOptions: any;
  public defaultHeaders = new HttpHeaders();
  public notificationPropertiesData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  companyId: any;
  public notificationServicesConfiguration: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  constructor(private http: HttpClient) {

  }

  getCommonData(publicId: string) {
    this.getNotificationProperties(publicId);
    this.getNotificationServicesConfiguration(publicId);
  }

  async getNotificationProperties(publicId: string) {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling notification properties.');
    }
    try {
      const tempNotificationProperties = await this.http.get(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/notification.properties`).toPromise();
      this.setNotificationPropertiesSharedData(tempNotificationProperties);
    }
    catch (error) {
      this.setNotificationPropertiesSharedData(null);
      console.log('Failed while trying to get the notification properties.' + error)
    }
  }

  async getNotificationServicesConfiguration(publicId: string) {
    if (publicId === null || publicId === undefined) {
      throw new Error('Required parameter publicId was null or undefined when calling notification services configuration.');
    }
    try {
      const tempNotificationServicesConfig = await this.http.get(`${this._kcmssvcURL}/customers/${encodeURIComponent(String(publicId))}/configurations/notification_services.configuration`).toPromise();
      this.setNotificationServicesConfigurationSharedData(tempNotificationServicesConfig);
    }
    catch (error) {
      this.setNotificationServicesConfigurationSharedData(null);
      console.log('Failed while trying to get the notification services configuration.' + error)
    }
  }

  getNotificationPropertiesSharedData(): Observable<any> {
    return this.notificationPropertiesData.asObservable();
  }
  setNotificationPropertiesSharedData(data: any) {
    this.notificationPropertiesData.next(data);
  }

  getNotificationServicesConfigurationSharedData(): Observable<any>{
    return this.notificationServicesConfiguration.asObservable();
  }

  setNotificationServicesConfigurationSharedData(data:any){
    this.notificationServicesConfiguration.next(data);
  }
}
